import { mixpanelObject } from './analytics';
import {
  MIXPANEL_NOT_AVAILABLE,
  MIXPANEL_DESCRIPTION,
  MIXPANEL_ELEMENT,
  MIXPANEL_CTA,
  MIXPANEL_PAGE_TAG,
  MIXPANEL_EVENTS_SCREEN_VIEW,
  MIXPANEL_PAGE_NAME,
  MIXPANEL_GAMIFICATION_STAGE,
  MIXPANEL_GAMIFICATION_QUESTION_NUMBER,
  MIXPANEL_GAMIFICATION_OPTION_SELECTED
} from './analytics/mixpanel/mixpanelConstants';
import { basicInitializer } from './analytics/mixpanel/mixpanelEventsHelper';
import { EVENT_NAME } from './constants/stringConstants';

enum QuizPageNames {
  LANDING = 'Quiz Landing',
  PLAY = 'Quiz Play',
  CONFIRMATION = 'Quiz Confirmation'
}

enum QuizElements {
  PLAY = 'Play Quiz',
  PAST_WINNERS = 'Past Winners'
}

enum QuizStages {
  POPUP_LAUNCH = 'Quiz Popup Launch',
  LANDING = 'Quiz Landing',
  START = 'Quiz Start',
  PLAY = 'Quiz Play',
  END = 'Quiz End',
  CONFIRMATION = 'Quiz confirmation'
}

enum QuizDescriptions {
  WATCH_AND_WIN_CLICK = 'When User clicks on Watch and Win ',
  PAST_WINNERS_CLICK = 'When user clicks on Past Winners',
  PLAY_NOW_CLICK = 'Watch and Win Page Landing',
  QUIZ_PAGE_CLICK = 'When user clicks on Watch and Win quiz Page',
  QUIZ_PAGE_LAND = 'When user lands on Watch and Win quiz Page',
  QUIZ_END = 'Quiz End Landing'
}

export const triggerPlayQuizCTAEvent = (gameMapperId: string) => {
  mixpanelObject.setProperty(MIXPANEL_PAGE_NAME, QuizPageNames.LANDING);
  mixpanelObject.setProperty(MIXPANEL_ELEMENT, QuizElements.PLAY);
  const trackObject = basicInitializer(mixpanelObject, true);
  trackObject[MIXPANEL_DESCRIPTION] = QuizDescriptions.WATCH_AND_WIN_CLICK;
  trackObject[MIXPANEL_GAMIFICATION_STAGE] = QuizStages.POPUP_LAUNCH;
  trackObject[MIXPANEL_PAGE_TAG] = gameMapperId || MIXPANEL_NOT_AVAILABLE;
  mixpanelObject.trackEvent(MIXPANEL_CTA, trackObject);
};

const USER_LANDS_ON_CONTEST_WINNER_PAGE =
  'When User lands on Winner & Contest page';
const WINNER_AND_CONTEST_PAGE = 'Winner & Contest';
const LEADERBOARD = 'Leaderboard';

export const triggerContestWinnerPageEvent = (gameMapperId: string) => {
  const trackObject = basicInitializer(mixpanelObject);
  trackObject[MIXPANEL_DESCRIPTION] =
    USER_LANDS_ON_CONTEST_WINNER_PAGE || MIXPANEL_NOT_AVAILABLE;
  trackObject[EVENT_NAME] = MIXPANEL_EVENTS_SCREEN_VIEW;
  trackObject[MIXPANEL_PAGE_NAME] = WINNER_AND_CONTEST_PAGE;
  trackObject[MIXPANEL_GAMIFICATION_STAGE] = LEADERBOARD;
  trackObject[MIXPANEL_PAGE_TAG] = gameMapperId || MIXPANEL_NOT_AVAILABLE;
  mixpanelObject.trackEvent(MIXPANEL_EVENTS_SCREEN_VIEW, trackObject);
};
export const triggerPastWinnersCTAEvent = (gameMapperId: string) => {
  mixpanelObject.setProperty(MIXPANEL_PAGE_NAME, QuizPageNames.CONFIRMATION);
  mixpanelObject.setProperty(MIXPANEL_ELEMENT, QuizElements.PAST_WINNERS);
  const trackObject = basicInitializer(mixpanelObject, true);
  trackObject[MIXPANEL_DESCRIPTION] = QuizDescriptions.PAST_WINNERS_CLICK;
  trackObject[MIXPANEL_GAMIFICATION_STAGE] = QuizStages.END;
  trackObject[MIXPANEL_PAGE_TAG] = gameMapperId || MIXPANEL_NOT_AVAILABLE;
  mixpanelObject.trackEvent(MIXPANEL_CTA, trackObject);
};

export const triggerQuizLandingPageEvent = (gameMapperId: string) => {
  mixpanelObject.setProperty(MIXPANEL_PAGE_NAME, QuizPageNames.LANDING);
  const trackObject = basicInitializer(mixpanelObject);
  trackObject[MIXPANEL_DESCRIPTION] = QuizDescriptions.PLAY_NOW_CLICK;

  trackObject[MIXPANEL_GAMIFICATION_STAGE] = QuizStages.LANDING;
  trackObject[MIXPANEL_PAGE_TAG] = gameMapperId || MIXPANEL_NOT_AVAILABLE;
  mixpanelObject.trackEvent(MIXPANEL_EVENTS_SCREEN_VIEW, trackObject);
};

const USER_TOGGLES_CONTEST_WINNER = 'When User Toggles contest/winner';
const MIXPANEL_TAB_SELECT = 'Tab Select';
const MIXPANEL_TAB_NAME = 'Tab Name';
const MIXPANEL_DATE_SELECTED = 'Date Selected';

export const triggerContestWineersTabSelect = (
  gameMapperId: string,
  selectedTab: string
) => {
  const trackObject = basicInitializer(mixpanelObject);
  trackObject[MIXPANEL_DESCRIPTION] =
    USER_TOGGLES_CONTEST_WINNER || MIXPANEL_NOT_AVAILABLE;
  trackObject[EVENT_NAME] = MIXPANEL_TAB_SELECT;
  trackObject[MIXPANEL_PAGE_NAME] = WINNER_AND_CONTEST_PAGE;
  trackObject[MIXPANEL_TAB_NAME] = selectedTab || MIXPANEL_NOT_AVAILABLE;
  trackObject[MIXPANEL_PAGE_TAG] = gameMapperId || MIXPANEL_NOT_AVAILABLE;
  mixpanelObject.trackEvent(MIXPANEL_TAB_SELECT, trackObject);
};

const USER_TOGGLES_YESTERDAY_DAY_BEFORE =
  'When User toggles Yesterday/Day Before';
export const triggerContestWineersDateSelect = (
  gameMapperId: string,
  selectedDate: string
) => {
  mixpanelObject.setProperty(MIXPANEL_ELEMENT, selectedDate);
  const trackObject = basicInitializer(mixpanelObject);
  trackObject[MIXPANEL_DESCRIPTION] =
    USER_TOGGLES_YESTERDAY_DAY_BEFORE || MIXPANEL_NOT_AVAILABLE;
  trackObject[EVENT_NAME] = MIXPANEL_TAB_SELECT;
  trackObject[MIXPANEL_PAGE_NAME] = WINNER_AND_CONTEST_PAGE;
  trackObject[MIXPANEL_PAGE_TAG] = gameMapperId || MIXPANEL_NOT_AVAILABLE;
  trackObject[MIXPANEL_DATE_SELECTED] = selectedDate || MIXPANEL_NOT_AVAILABLE;
  mixpanelObject.trackEvent(MIXPANEL_TAB_SELECT, trackObject);
};
export const triggerQuizCTAEvent = (
  gameMapperId: string,
  element: string,
  questionId: string,
  selectedAnswerId?: string | null
) => {
  mixpanelObject.setProperty(MIXPANEL_PAGE_NAME, QuizPageNames.PLAY);
  mixpanelObject.setProperty(MIXPANEL_ELEMENT, element);
  const trackObject = basicInitializer(mixpanelObject, true);
  trackObject[MIXPANEL_DESCRIPTION] = QuizDescriptions.QUIZ_PAGE_CLICK;

  trackObject[MIXPANEL_GAMIFICATION_STAGE] = QuizStages.PLAY;
  trackObject[MIXPANEL_GAMIFICATION_OPTION_SELECTED] = selectedAnswerId;
  trackObject[MIXPANEL_GAMIFICATION_QUESTION_NUMBER] = questionId;
  trackObject[MIXPANEL_PAGE_TAG] = gameMapperId || MIXPANEL_NOT_AVAILABLE;
  mixpanelObject.trackEvent(MIXPANEL_CTA, trackObject);
};

export const triggerQuizPageEvent = (gameMapperId: string) => {
  mixpanelObject.setProperty(MIXPANEL_PAGE_NAME, QuizPageNames.PLAY);
  const trackObject = basicInitializer(mixpanelObject);
  trackObject[MIXPANEL_DESCRIPTION] = QuizDescriptions.QUIZ_PAGE_LAND;

  trackObject[MIXPANEL_GAMIFICATION_STAGE] = QuizStages.START;
  trackObject[MIXPANEL_PAGE_TAG] = gameMapperId || MIXPANEL_NOT_AVAILABLE;
  mixpanelObject.trackEvent(MIXPANEL_EVENTS_SCREEN_VIEW, trackObject);
};

export const triggerQuizEndingEvent = (gameMapperId: string) => {
  mixpanelObject.setProperty(MIXPANEL_PAGE_NAME, QuizPageNames.CONFIRMATION);
  const trackObject = basicInitializer(mixpanelObject);
  trackObject[MIXPANEL_DESCRIPTION] = QuizDescriptions.QUIZ_END;

  trackObject[MIXPANEL_GAMIFICATION_STAGE] = QuizStages.CONFIRMATION;
  trackObject[MIXPANEL_PAGE_TAG] = gameMapperId || MIXPANEL_NOT_AVAILABLE;
  mixpanelObject.trackEvent(MIXPANEL_EVENTS_SCREEN_VIEW, trackObject);
};

export const getFullNameObj = (fullName: string) => {
  const splitName = fullName?.split(' ');
  const first_name = splitName?.[0] || '';
  let last_name = '';
  if (splitName?.length > 1) {
    splitName.shift();
    last_name = splitName?.join(' ');
  }
  return { first_name, last_name };
};

export const parseGameMapperId = (gameMapperIdParam: string) => {
  const decodedParam = decodeURIComponent(gameMapperIdParam);
  if (decodedParam.includes('?')) {
    return decodedParam.split('?')[0];
  }
  return decodedParam;
};
